import React, { useState } from 'react'
import Select from 'react-select'
import Creatable from "react-select/creatable"
import pluralize from 'pluralize'
import { LoadingOutlined, PlusOutlined } from '@ant-design/icons'
import { Drawer, DatePicker, Switch, Upload, message } from 'antd'

import { useListData, usePet, useToggle } from '../../modules'

import Modal from '../resusable/modal'
import Receive from '../resusable/receive'
import Confirm from '../resusable/confirm'

import Ingredients from '../modals/ingredients'
import Variant from '../modals/variant'

const { RangePicker } = DatePicker

const AssignGroup = ({ category, toggle, visible, groups, onComplete }) => {
    const [group, setGroup] = useState()

    const save = () => {
        onComplete(group)
        toggle()
    }

    return (
        <Modal
            h="h-auto"
            w="w-1/2 lg:w-1/3 xl:w-1/4"
            title="Assign Item Group"
            toggle={toggle}
            visible={visible}>
            <div className="w-full bg-white">
                <div className="flex flex-wrap -mx-3 mb-3">
                    <div className="w-full px-3 md:mb-0">
                        <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                            Item Group
                        </label>
                        <Select
                            value={ group }
                            options={ groups }
                            onChange={ setGroup } />
                    </div>
                </div>  
            </div>
            <div className="flex justify-end">
                <button onClick={ () => Confirm({
                    title: 'Save Changes?',
                    desc: 'Are you sure you want to save these changes?',
                    okText: 'Save Changes',
                    onOk: save
                }) } type="submit" className="text-white hisani-btn-orange font-medium rounded-lg text-sm px-5 py-2.5 text-center">Save</button>
            </div>
        </Modal>
    )
}

const NewSaleItem = ({ toggle, visible, onPerform }) => {
    const [name, setName] = useState(null)
    const [category, setCategory] = useState(null)
    const [invRef, setInvRef] = useState(null)
    const [itemGroup, setItemGroup] = useState(null)
    const [val, setVal] = useState(null)
    const [itemGroups, setItemGroups] = useState([])
    const [conversionRate, setConversionRate] = useState('1')

    const [price, setPrice] = useState(null)
    const [variants, setVariants] = useState([])
    const [categories, setCategories] = useState([])

    const [itemType, setItemType] = useState({ label: 'Service', value: 'Service' })
    const [ingredients, setIngredients] = useState([])
    const [imageUrl, setImageUrl] = useState(null)
    const [image, setImage] = useState(null)
    const [string, setString] = useState('')
    
    const [hasVariants, toggleHasVariants, setHasVariants] = useToggle()
    const [imgLoading, setImgLoading] = useState(false)
    const [ingredientsModal, toggleIngredientsModal] = useToggle()
    const [variantsModal, toggleVariantsModal] = useToggle()
    const [assignGroup, toggleAssignGroup] = useToggle()

    const [{ loading: invLoading, fetch: fetchInvItems }, { list: items = [] }] = useListData('inventoryItems', { string }, { notify: true }, 'items')
    
    const search = str => {
        if (str?.trim()?.length > 2) {
            setString(str)
            fetchInvItems()
        }
    }

    usePet('itemGroups', null, { notify: true, callback: ({ data }) => {
        data = data.filter(grp => grp.name !== 'Bill').map(grp => ({ label: grp.name, value: grp._id }))
        setItemGroups(data)
    } })

    const [{ loading: catsLoading, error: catsError }] = usePet('saleItemCategories', null, { notify: true, callback: ({ data }) => setCategories(data) })

    let types = ["Prepared Item", "Sale Item", "Service"]

    const modify = e => {
        switch (e.target.name) {
            case 'name':
                setName(e.target.value)
                break

            case 'price':
                setPrice(e.target.value)
                break

            case 'conversion-rate':
                setConversionRate(e.target.value)
                break

            default:
                break
        }
    }

    const getBase64 = (img, callback) => {
        const reader = new FileReader()
        reader.addEventListener('load', () => callback(reader.result))
        reader.readAsDataURL(img)
    }

    const beforeUpload = file => {
        const isImage = file.type === 'image/jpeg' || file.type === 'image/png'
        if (!isImage) {
            message.warning('Please select an image file')
            return false
        }

        const sizeOK = file.size / 1024 / 1024 <= 1
        if (!sizeOK) {
            message.warning('Please select an image smaller than 1MB')
            return false
        }

        setImageUrl(null)
        setImage(file)
        setImgLoading(true)

        setTimeout(() => {
            setImageUrl(URL.createObjectURL(file))
            setImgLoading(false)
        }, 1000)

        return false
    }

    const newCategory = vl => {
        setVal(vl)
        toggleAssignGroup()
    }

    const addCategory = grp => {
        setItemGroup(grp)
        let temp = [...categories]
        temp.push(val)
        setCategories(temp)
        setCategory({ label: val, value: val })
    }

    const handleChange = info => {
        if (info.file.status === 'uploading') {
            setImgLoading(true)
            return
        }

        if (info.file.status === 'done') {
            getBase64(info.file.originFileObj, url => {
                setImageUrl(url)
                setImgLoading(false)
            })
        }
    }

    const removeImage = () => {
        setImage(null)
        setImageUrl(null)
    }

    const deleteIngredient = i => {
        let temp = [...ingredients]
        temp = temp.filter((_, index) => i !== index)

        setIngredients(temp)
    }

    const addVariant = vrnt => {
        let temp = [...variants]
        temp.push(vrnt)

        setVariants(temp)
    }

    const deleteVariant = i => {
        let temp = [...variants]
        temp = temp.filter((_, index) => i !== index)

        setVariants(temp)
    }

    const close = () => {   
        setTimeout(() => {
            setName('')
            setCategory(null)
            setInvRef()
            setItemGroup()
            setVal()
            setConversionRate()
            setPrice(0)
            setVariants([])
            setIngredients([])
            setImage()
            setImageUrl()
            setString() 
            setHasVariants(false)
        }, 300)
        toggle()
    }

    const onComplete = ({}, notif, ops) => {
        onPerform()
        notif('New item has been added', ops('success'))
        
        setTimeout(close, 300)
    }

    const [{ loading }, execute] = usePet(hasVariants ? 'newSaleItemWithVariants' : 'newSaleItem', {
        name,
        type: itemType?.value,
        ref: invRef ? invRef._id : null,
        itemGroup: itemGroup ? itemGroup?.value : null,
        category: category?.value,
        ingredients: ingredients?.map(itm => ({
            item: itm._id,
            quantity: itm.qty
        })),
        variants: variants.map(({ name: nm, conversionRate, price: prc, ref, ingredients: ing, image: img }) => ({
            name: nm,
            price: prc,
            conversionRate,
            ref: ref ? ref._id : null,
            ingredients: ing?.map(itm => ({
                item: itm._id,
                quantity: itm.qty
            }))
        })),
        price,
        image,
        variantImages: variants.map(({ image }) => image),
        conversionRate
    }, { notify: true, hasFile: true, callback: onComplete, manual: true, load: { msg: 'Adding new item...' } })

    const save = () => Confirm({
        title: 'Add New Item',
        message: 'Are you sure you want to add this item?',
        onOk: execute,
        okText: 'Add Item'
    })

    return (
        <Drawer
            closable
            maskClosable
            visible={visible}
            onClose={ close }
            footer={
                <div className="w-full text-right">
                    <button disabled={ loading } onClick={ save } type="submit" className="text-white hisani-btn-orange font-medium rounded-lg text-sm px-5 mr-2 py-2.5 text-center">Save</button>
                    <button onClick={ close } className="text-white bg-gray-500 hover:bg-gray-600 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center">Close</button>
                </div>
            }
            width="500px">
            <p className="font-extrabold text-3xl mb-0">New Sale Item</p>
            <div className="divide-y divide-light-gray-400">
                {
                    assignGroup &&
                    <AssignGroup
                        groups={ itemGroups }
                        onComplete={ addCategory }
                        toggle={ toggleAssignGroup }
                        visible={ assignGroup } />
                }
                <Variant
                    setString={ setString }
                    loading={ invLoading }
                    fetch={ fetchInvItems }
                    items={ items }
                    type={ itemType }
                    onSave={ addVariant}
                    visible={variantsModal}
                    toggle={toggleVariantsModal} />
                <Ingredients
                    ingredients={ ingredients }
                    onSave={setIngredients}
                    visible={ingredientsModal}
                    toggle={toggleIngredientsModal} />
                {/* <div className="w-full flex flex-col md:flex-row"> */}
                    {/* <div className="w-full lg:w-7/12 bg-white p-5"> */}
                        <div className="flex flex-wrap -mx-3 pt-5 mb-3">
                            <div className="w-full md:w-1/2 px-3 mb-6 md:mb-0">
                                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                                    Name
                                </label>
                                <input
                                    className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                                    id="grid-name"
                                    onChange={modify}
                                    value={name}
                                    type="text"
                                    name="name"
                                    placeholder="French Fries" />
                            </div>
                            <div className="w-full md:w-1/2 px-3 mb-3 md:mb-0">
                                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                                    Type
                                </label>
                                <Select
                                    value={itemType}
                                    onChange={ val => {
                                        setItemType(val)
                                        setIngredients([])
                                        setVariants([])
                                        setInvRef(null)
                                    }}
                                    options={types.map(type => ({ label: type, value: type }))}
                                    placeholder="Select Type" />
                            </div>
                        </div>
                        <div className="flex flex-wrap -mx-3 pt-5 mb-3">
                            <div className="w-full md:w-3/12 h-auto text-center m-auto lg:block lg:w-5/12">
                                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                                    Upload Image
                                </label>
                                <Upload
                                    name="avatar"
                                    listType="picture-card"
                                    className="avatar-uploader"
                                    showUploadList={false}
                                    action="https://www.mocky.io/v2/5cc8019d300000980a055e76"
                                    beforeUpload={beforeUpload}
                                    onChange={handleChange}>
                                    {
                                        imageUrl ?
                                            <img
                                                src={imageUrl}
                                                alt="avatar"
                                                style={{ width: '100%' }} />
                                            :
                                            <div>
                                                {imgLoading ? <LoadingOutlined /> : <PlusOutlined />}
                                                <div style={{ marginTop: 8 }}>{imgLoading ? 'Generating preview...' : 'Upload image'}</div>
                                            </div>
                                    }
                                </Upload>
                                {
                                    image && <p onClick={removeImage} className="text-red-500 cursor-pointer text-xs italic">X Remove</p>
                                }
                            </div>
                        </div>
                        {
                            itemType &&
                            <>
                                <div className="flex flex-wrap -mx-3 pt-4 mb-3">
                                    <div className="w-full md:w-1/2 px-3 mb-6 md:mb-0">
                                        <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                                            Variants
                                        </label>
                                        <div>
                                            <Switch
                                                onChange={ () => {
                                                    toggleHasVariants()
                                                    setIngredients([])
                                                    setPrice(null)
                                                }}
                                                checked={hasVariants} />
                                            <p className="text-gray-500 text-xs italic">Has different types</p>
                                        </div>
                                    </div>
                                    <div className="w-full md:w-1/2 px-3 mb-6 md:mb-0">
                                        <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                                            Category
                                        </label>
                                        <Receive
                                            loading={catsLoading}
                                            error={catsError}>
                                            <Creatable
                                                value={category}
                                                onCreateOption={ newCategory }
                                                onChange={setCategory}
                                                options={categories.map(cat => ({ label: cat, value: cat }))}
                                                placeholder="Select Category" />
                                        </Receive>
                                    </div>
                                </div>
                                {
                                    hasVariants &&
                                    <div className="font-bold mt-3">
                                        <div className="flex justify-between items-center">
                                            <p className="font-bold my-3">Variants</p>
                                            <button onClick={toggleVariantsModal} className="btn hisani-btn-green text-white my-3">
                                                <svg className="w-4 h-4 fill-current opacity-50 flex-shrink-0" viewBox="0 0 16 16">
                                                    <path d="M15 7H9V1c0-.6-.4-1-1-1S7 .4 7 1v6H1c-.6 0-1 .4-1 1s.4 1 1 1h6v6c0 .6.4 1 1 1s1-.4 1-1V9h6c.6 0 1-.4 1-1s-.4-1-1-1z" />
                                                </svg>
                                                <span className="hidden xs:block ml-2">Add</span>
                                            </button>
                                        </div>
                                        {
                                            variants?.length > 0 ?
                                                <table className="table-auto w-full mb-3">
                                                    {/* Table header */}
                                                    <thead className="text-xs uppercase text-gray-400 bg-gray-50 rounded-sm">
                                                        <tr>
                                                            <th className="p-2">
                                                                <div className="font-semibold text-left">No</div>
                                                            </th>
                                                            <th className="p-2">
                                                                <div className="font-semibold text-left">Variant</div>
                                                            </th>
                                                            <th className="p-2">
                                                                <div className="font-semibold text-left">C / Rate</div>
                                                            </th>
                                                            <th className="p-2">
                                                                <div className="font-semibold text-left">Price</div>
                                                            </th>
                                                            <th />
                                                        </tr>
                                                    </thead>
                                                    {/* Table body */}
                                                    <tbody className="text-sm font-medium divide-y divide-gray-100">
                                                        {
                                                            variants.map((variant, key) =>
                                                                <tr>
                                                                    <td className="p-2 text-left">{key + 1}</td>
                                                                    <td className="p-2 text-left">{variant.name}</td>
                                                                    <td className="p-2 text-left">{variant.conversionRate}</td>
                                                                    <td className="p-2 text-left">Ksh. {variant.price}</td>
                                                                    <td onClick={() => deleteVariant(key)} className="p-2 text-left text-red-500 cursor-pointer">X</td>
                                                                </tr>
                                                            )
                                                        }
                                                    </tbody>
                                                </table>
                                                :
                                                <div className="text-center my-4">
                                                    <h3>Please click above to add variants</h3>
                                                </div>
                                        }
                                    </div>
                                }
                                <div className="flex flex-wrap -mx-3 pt-4 mb-3">
                                    {
                                        !hasVariants &&
                                        <>
                                            <div className="w-full md:w-1/2 px-3 mb-6 md:mb-0">
                                                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                                                    Price
                                                </label>
                                                <input
                                                    className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                                                    id="grid-price"
                                                    value={price}
                                                    onChange={modify}
                                                    name="price"
                                                    type="number"
                                                    placeholder="XXXX" />
                                            </div>
                                            {
                                                itemType?.value === 'Sale Item' &&
                                                <div className="w-full md:w-1/2 px-3 mb-6 md:mb-0">
                                                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                                                        Conversion Rate
                                                    </label>
                                                    <input
                                                        className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                                                        id="grid-conversion-rate"
                                                        type="text"
                                                        name="conversion-rate"
                                                        value={conversionRate}
                                                        onChange={modify}
                                                        placeholder="1/2" />
                                                </div>
                                            }
                                        </>
                                    }
                                </div>
                                {
                                    !hasVariants ?
                                        itemType?.value === 'Prepared Item' ?
                                            <div className="font-bold mt-3">
                                                <div className="flex justify-between items-center">
                                                    <p className="font-bold my-3">Ingredients</p>
                                                    <button onClick={toggleIngredientsModal} className="btn hisani-btn-green text-white my-3">
                                                        <svg className="w-4 h-4 fill-current opacity-50 flex-shrink-0" viewBox="0 0 16 16">
                                                            <path d="M15 7H9V1c0-.6-.4-1-1-1S7 .4 7 1v6H1c-.6 0-1 .4-1 1s.4 1 1 1h6v6c0 .6.4 1 1 1s1-.4 1-1V9h6c.6 0 1-.4 1-1s-.4-1-1-1z" />
                                                        </svg>
                                                        <span className="hidden xs:block ml-2">Add</span>
                                                    </button>
                                                </div>
                                                {
                                                    ingredients?.length > 0 ?
                                                        <table className="table-auto w-full mb-3">
                                                            {/* Table header */}
                                                            <thead className="text-xs uppercase text-gray-400 bg-gray-50 rounded-sm">
                                                                <tr>
                                                                    <th className="p-2">
                                                                        <div className="font-semibold text-left">No</div>
                                                                    </th>
                                                                    <th className="p-2">
                                                                        <div className="font-semibold text-left">Selected</div>
                                                                    </th>
                                                                    <th className="p-2">
                                                                        <div className="font-semibold text-left">Quantity</div>
                                                                    </th>
                                                                    <th />
                                                                </tr>
                                                            </thead>
                                                            {/* Table body */}
                                                            <tbody className="text-sm font-medium divide-y divide-gray-100">
                                                                {
                                                                    ingredients.map((ingredient, key) =>
                                                                        <tr>
                                                                            <td className="p-2 text-left">{key + 1}</td>
                                                                            <td className="p-2 text-left">{ingredient.name}</td>
                                                                            <td className="p-2 text-left">{ingredient.qty} {pluralize(ingredient.issuedIn, ingredient.qty)}</td>
                                                                            <td onClick={ () => deleteIngredient(key) } className="p-2 text-left text-red-500 cursor-pointer">X</td>
                                                                        </tr>
                                                                    )
                                                                }
                                                            </tbody>
                                                        </table>
                                                        :
                                                        <div className="text-center my-4">
                                                            <h3>Please click above to add ingredients</h3>
                                                        </div>
                                                }
                                            </div>
                                            : itemType?.value === 'Sale Item' ?
                                                <div className="flex flex-wrap -mx-3 pt-4 mb-6 bt-1 border-gray-200">
                                                    <div className="w-full md:w-2/3 px-3 mb-6 md:mb-0">
                                                        <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                                                            Inventory Item
                                                        </label>
                                                        <Select
                                                            isLoading={invLoading}
                                                            loadingMessage={string => `Searching for "${string?.inputValue}"`}
                                                            onInputChange={search}
                                                            value={invRef}
                                                            onChange={setInvRef}
                                                            options={items.map(item => ({ label: item.name, value: item._id, ...item }))}
                                                            placeholder="Search for inventory item" />
                                                        <p className="text-gray-500 text-xs italic">Which inventory item does it refer to?</p>
                                                    </div>
                                                </div>
                                                : null
                                        : null
                                }
                            </>
                        }
                    {/* </div>
                </div> */}
            </div>            
        </Drawer>
    )
}

export default NewSaleItem